import "../src/assets/styles/styles.css";
import React from "react";
import Form from "./Components/form/Form";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import CodeVerifier from "./Components/staff/VerifyCode";
import RemoveService from "./Components/admin/RemoveService";
import ServiceSetup from './Components/admin/ServiceSetup';
import AddService from "./Components/admin/AddService";
import Success from "./Components/form/ReservationSuccess";
import ServiceQueue from "./Components/staff/ServiceQueue";
import StudentData from "./Components/staff/StudentData";
import Login from "./Components/user/Login";
import AdminProtectedRoute from "./Components/admin/AdminProtectedRoute";
import StaffProtectedRoute from "./Components/staff/StaffProtectedRoute";
import AddUser from "./Components/admin/AddUser";
import Users from "./Components/admin/ViewUser";
import ResetPassword from "./Components/user/ResetPassword";
import ForgotPassword from "./Components/user/ForgotPassword";

function App() {

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/login" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/form" component={Form} />
        <StaffProtectedRoute path="/serviceQueue" component={ServiceQueue} />
        <StaffProtectedRoute path="/verify" component={CodeVerifier} />
        <AdminProtectedRoute path="/setupService" component={ServiceSetup} />
        <AdminProtectedRoute path="/addUser" component={AddUser} />
        <AdminProtectedRoute path="/users" component={Users} />
        <AdminProtectedRoute path="/addService" component={AddService} />
        <Route path="/reservationSuccessful" component={Success} />
        <StaffProtectedRoute path="/biodata/:id" component={StudentData} />
        <AdminProtectedRoute path="/removeService" component={RemoveService} />
        <Route path="/reset-password" component={ResetPassword} />
      </Switch>
    </BrowserRouter>
  )
}
export default App;
